import LegalPage, { type BusinessIdentity } from '../../components/LegalPage'

interface Props {
  business: BusinessIdentity
}

// Full document text lives in config/locales under frontend.legal.terms.
export default function Terms({ business }: Props) {
  return <LegalPage page="terms" business={business} />
}
